import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { IContentGroup } from '../../../store/models/content-group.model';
import { EMenuButtonItemType, IMenuButtonProperties } from '../../../store/models/menu-button.model';

@Component({
  selector: 'app-content-group-listing-mobile-row',
  templateUrl: './content-group-listing-mobile-row.component.html',
  styleUrls: ['./content-group-listing-mobile-row.component.scss'],
})
export class ContentGroupListingMobileRowComponent implements OnInit {

  @Input() item: IContentGroup;

  @Output() update: EventEmitter<IContentGroup> = new EventEmitter<IContentGroup>();
  @Output() request: EventEmitter<IContentGroup> = new EventEmitter<IContentGroup>();

  componentReady = false;

  menuItems: IMenuButtonProperties = {
    items: [
      {
        label: 'Edit',
        type: EMenuButtonItemType.LINK,
        getRoute: (target: IContentGroup) => ([
          '/contents',
          target.content_group_id,
          'content',
          {
            group_name: target.content_group,
          },
        ]),
      },
      {
        label: 'Update',
        type: EMenuButtonItemType.BUTTON,
        onClick: (target: IContentGroup) => this.update.emit(target),
      },
    ],
  };

  constructor() {
  }

  ngOnInit(): void {
    if (this.item) {
      this.menuItems.items.push({
        label: this.item.content_requested
          ? 'Help requested has been sent'
          : 'Request Help with Content',
        type: EMenuButtonItemType.BUTTON,
        onClick: (target: IContentGroup) => this.request.emit(target),
        disabled: this.item.content_requested,
      });

      this.componentReady = true;
    }
  }

}
